import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger } from '@angular/material/menu';
import { StudentCommunicationEvent } from '../../../model/student-communication-events';

@Component({
    selector: 'get-student-with-same-communication-event-btn',
    templateUrl: './get-student-with-same-communication-event-btn.component.html',
    styleUrls: ['./get-student-with-same-communication-event-btn.component.scss']
})
export class GetStudentWithSameCommunicationEventBtnComponent implements OnInit {
    @Input() studentCommunicationEvent: StudentCommunicationEvent;

    @Output() onConfirm: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('confirmElement') confirmElement!: MatButton;

    dataBsPopover: string = 'focus';

    @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

    filters = {
        'Match Communication Type': {
            index: 1,
            checked: true,
            enabled: false
        },
        'Match Communication Date': {
            index: 2,
            checked: true,
            enabled: false
        },
        'Match Region': {
            index: 3,
            checked: false,
            enabled: true
        },
        'Match Comment': {
            index: 4,
            checked: false,
            enabled: true
        },
        'Match Creator': {
            index: 5,
            checked: false,
            enabled: true
        },
        'Match Created Date': {
            index: 6,
            checked: false,
            enabled: true
        },
        'Match Updater': {
            index: 7,
            checked: false,
            enabled: true
        },
        'Match Updated Date': {
            index: 8,
            checked: false,
            enabled: true
        }
    };

    constructor() {}

    ngOnInit(): void {}

    confirm(searchType: string) {
        this.onConfirm.emit({ studentCommunicationEvent: this.studentCommunicationEvent, filters: this.filters, searchType: searchType });
        this.menuTrigger.closeMenu();
    }

    openMenu() {
        this.confirmElement.focus();
    }

    closeMenu() {
        this.menuTrigger.closeMenu();
    }

    getStudentsWithSameCommunicationEvent() {}
}
